import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterBar = ({
  searchQuery,
  onSearchChange,
  selectedStatus,
  onStatusChange,
  selectedCategory,
  onCategoryChange,
  selectedLanguage,
  onLanguageChange,
  selectedExpert,
  onExpertChange,
  experts
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'upcoming', label: 'Upcoming' },
    { value: 'live', label: 'Live' },
    { value: 'completed', label: 'Recorded' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
    { value: 'Machine Learning', label: 'Machine Learning' },
    { value: 'Data Science', label: 'Data Science' },
    { value: 'Robotics', label: 'Robotics' },
    { value: 'Cloud Computing', label: 'Cloud Computing' },
    { value: 'Big Data', label: 'Big Data' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Management', label: 'Management' },
    { value: 'Medicine', label: 'Medicine' },
    { value: 'Law', label: 'Law' },
    { value: 'Arts', label: 'Arts' }
  ];

  const languageOptions = [
    { value: 'all', label: 'All Languages' },
    { value: 'English', label: 'English' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Tamil', label: 'Tamil' },
    { value: 'Telugu', label: 'Telugu' },
    { value: 'Kannada', label: 'Kannada' },
    { value: 'Bengali', label: 'Bengali' },
    { value: 'Marathi', label: 'Marathi' },
    { value: 'Gujarati', label: 'Gujarati' }
  ];

  const expertOptions = [
    { value: 'all', label: 'All Experts' },
    ...(experts?.map((expert) => ({
      value: expert?.id,
      label: expert?.name
    })) || [])
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 mb-6 md:mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search webinars, experts, or topics..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        <Select
          value={selectedStatus}
          onChange={onStatusChange}
          options={statusOptions}
        />
        <Select
          value={selectedCategory}
          onChange={onCategoryChange}
          options={categoryOptions}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <Select
          value={selectedLanguage}
          onChange={onLanguageChange}
          options={languageOptions}
        />
        {experts?.length > 0 && (
          <Select
            value={selectedExpert}
            onChange={onExpertChange}
            options={expertOptions}
          />
        )}
      </div>
    </div>
  );
};

export default FilterBar;